function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "13"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#acacac",
  d: "M10 1.562v.625c0 .173-.14.313-.313.313H.312A.313.313 0 010 2.187v-.625c0-.172.14-.312.312-.312h2.813V.625c0-.345.28-.625.625-.625h2.5c.345 0 .625.28.625.625v.625h2.812c.173 0 .313.14.313.312zm-8.831 9.775a1.25 1.25 0 001.25 1.163h5.175a1.25 1.25 0 001.25-1.163l.531-7.587H.625l.544 7.587z"
})));